"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_MAP_COLOR = void 0;
var DEFAULT_MAP_COLOR = {
  'red': 'poi-marker-red.png',
  'blue': 'poi-marker-blue.png',
  'purple': 'poi-marker-purple.png',
  'black': 'poi-marker-black.png'
};
exports.DEFAULT_MAP_COLOR = DEFAULT_MAP_COLOR;